import { type TokenGroup } from "../../types";

export const gray = {
  name: "gray",
  variables: {
    "1": { type: "color", value: { dark: "#1a1a1a", light: "#ffffff" } },
    "2": { type: "color", value: { dark: "#202020", light: "#fbfbfa" } },
    "3": { type: "color", value: { dark: "#262626", light: "#f6f6f6" } },
    "4": { type: "color", value: { dark: "#2d2d2d", light: "#efefef" } },
    "5": { type: "color", value: { dark: "#333333", light: "#dcdcdc" } },
    "6": { type: "color", value: { dark: "#3f3e3e", light: "#cecece" } },
    "7": { type: "color", value: { dark: "#4d4d4d", light: "#c1c1c1" } },
    "8": { type: "color", value: { dark: "#666666", light: "#a4a4a4" } },
    "9": { type: "color", value: { dark: "#a4a4a4", light: "#808080" } },
    "10": { type: "color", value: { dark: "#c1c1c1", light: "#666666" } },
    "11": { type: "color", value: { dark: "#dcdcdc", light: "#4d4d4d" } },
    "12": { type: "color", value: { dark: "#f6f6f6", light: "#202020" } },
  },
} as const satisfies TokenGroup<"gray">;
